import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75ca73d3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box"
};
const _hoisted_2 = {
  key: 0,
  viewBox: "0 0 100 100",
  class: "item"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "5",
  width: "90",
  height: "90",
  fill: "#000"
}, null, -1));
const _hoisted_4 = [_hoisted_3];
const _hoisted_5 = {
  key: 1,
  viewBox: "0 0 100 100",
  class: "item"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "5",
  width: "90",
  height: "90",
  fill: "none",
  stroke: "#000"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 2,
  viewBox: "0 0 100 100",
  class: "item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "5",
  width: "90",
  height: "90",
  fill: "none",
  stroke: "#000"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "5",
  x2: "95",
  y2: "95",
  stroke: "#000"
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "95",
  y1: "5",
  x2: "5",
  y2: "95",
  stroke: "#000"
}, null, -1));
const _hoisted_12 = [_hoisted_9, _hoisted_10, _hoisted_11];
const _hoisted_13 = {
  key: 3,
  viewBox: "0 0 100 100",
  class: "item"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "5",
  width: "90",
  height: "90",
  fill: "none",
  stroke: "#000"
}, null, -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "95",
  y1: "5",
  x2: "5",
  y2: "95",
  stroke: "#000"
}, null, -1));
const _hoisted_16 = [_hoisted_14, _hoisted_15];
const _hoisted_17 = {
  key: 4,
  viewBox: "0 0 100 100",
  class: "item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "5",
  y: "5",
  width: "90",
  height: "90",
  fill: "none",
  stroke: "#000"
}, null, -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "5",
  y1: "5",
  x2: "95",
  y2: "95",
  stroke: "#000"
}, null, -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
export default {
  __name: 'NineGrid',
  props: {
    items: {
      type: Array,
      default: () => [[0, 1, 2], [3, 4, 3], [2, 1, 0]]
    }
  },
  setup(__props) {
    const props = __props;
    console.log(props.items);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items.flat(), item => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item
        }, [item === 0 ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4)) : _createCommentVNode("", true), item === 1 ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true), item === 2 ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_12)) : _createCommentVNode("", true), item === 3 ? (_openBlock(), _createElementBlock("svg", _hoisted_13, _hoisted_16)) : _createCommentVNode("", true), item === 4 ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_20)) : _createCommentVNode("", true)], 64);
      }), 128))]);
    };
  }
};